import React from 'react';
import { formatDate } from '@common/paymentsUtils/dateUtils';
import { addDays, isAfter, isSameDay, subDays } from 'date-fns';

interface CreateSelectOptionInterface {
  currentDate: Date;
  dueDate: Date;
}

const createSelectOption = ({ currentDate, dueDate }: CreateSelectOptionInterface) => {
  const currentDateFormatted = formatDate(currentDate, 'yyyy-MM-dd');
  const currentDateNumber = Number(formatDate(currentDate, 'd'));
  const currentDateOrdinal = currentDateNumber === 31 ? 'Last day' : formatDate(currentDate, 'do');
  const showDueDate = currentDate === dueDate ? ' (Due date)' : '';
  const showAsterisk = currentDateNumber === 29 || currentDateNumber === 30 ? ' *' : '';
  return (
    <option key={currentDateFormatted} value={currentDateFormatted}>
      {`${currentDateOrdinal} of the month${showDueDate}${showAsterisk}`}
    </option>
  );
};

const dropdownBuilder = (dueDate = new Date(), today = new Date()) => {
  const selectOptions: JSX.Element[] = [];

  // add the options for up to 10 days before the due date
  for (let i = 10; i > 0; i--) {
    const currentDate = subDays(dueDate, i);
    // add the option only if the entry is not in the past
    if (isSameDay(currentDate, today) || isAfter(currentDate, today)) {
      selectOptions.push(createSelectOption({ currentDate, dueDate }));
    }
  }

  // add the option for the due date
  selectOptions.push(createSelectOption({ currentDate: dueDate, dueDate }));

  // add the options for 4 days after the due date
  for (let j = 1; j < 5; j++) {
    const currentDate = addDays(dueDate, j);
    selectOptions.push(createSelectOption({ currentDate, dueDate }));
  }

  return selectOptions;
};

export default dropdownBuilder;
